<template>
<div>
  <form @submit.prevent="submit" autocomplete="off">
      <ui-alert type="error" v-for="e,index in errors" :key="index" :dismissible="false">{{ e }}</ui-alert>


      <ui-checkbox name="use_template" v-model="item.use_template">Użyj szablonu</ui-checkbox>
      <p v-if="item.use_template">
          Treść wiadomości zostanie wpisana do wybranego szablonu lub do domyślnego szablonu jeśli nie wybierzesz szablonu.
      </p>
      <div v-if="!item.use_template">
          <p>
              Ponieważ nie wybrałeś "użyj szablonu" musisz zadbać o to aby cała wiadomość html była kompletna (była kompletną podstroną html - zawierała znaczniki html, body, head oraz link do wypisania się z newslettera).
          </p>
          <p>
              <a @click.prevent="toggleHelp">Pokaż więcej informacji</a>
          </p>
          <div v-if="showHelp">
              <p>
                  Link do wypisania się z newslettera </p>

              <ui-textbox name="help" :disabled="true" v-model="help"></ui-textbox>
              <p>
                Link do potwierdzenia adresu e-mail
              </p>
              <ui-textbox name="help2" :disabled="true" v-model="help2"></ui-textbox>

          </div>
      </div>


      <ui-textbox v-if="item.import_html_url" label="Wybrany url z którego zaimportujemy treść" name="import_html_url" type="text" v-model="item.import_html_url" :disabled="true"></ui-textbox>

      <fieldset v-if="item.use_template">
          <legend>Szablon</legend>

          <i-select name="template_text" label="Szablon tekstowy" :keys="keysForTemplateSelect" v-model="item.template_text" :options="templates_text" placeholder="Wybierz szablon" required></i-select>

          <i-select name="template_html" label="Szablon html" :keys="keysForTemplateSelect" v-model="item.template_html" :options="templates_html" placeholder="Wybierz szablon" required></i-select>

      </fieldset>

      <fieldset>
          <legend>Treść wiadomości</legend>

          <ui-textbox label="Tytuł" name="title" type="text" v-model="item.title" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz tytuł wiadomości"></ui-textbox>

          <ui-textbox label="Treść tekstowa" name="text_body" type="text" v-model="item.text_body" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz treść tekstową" :multi-line="true" :rows="4"></ui-textbox>
          <ckeditor :fullpage="! item.use_template" :value="item.html_body" @input="inputC"></ckeditor>
          <a v-if="!item.use_template" @click.prevent="importUrl">Importuj treść wiadomości z podanego adresu url</a>
      </fieldset>

      <fieldset>
          <legend>Adresaci tej wiadomości</legend>

          <ui-checkbox name="send_to_all" v-model="item.send_to_all">Wszyscy</ui-checkbox>
          <div v-if="!item.send_to_all">
            <ui-checkbox name="send_to_confirmed" v-model="item.send_to_confirmed">Potwierdzone adresy e-mail</ui-checkbox>
            <ui-checkbox name="send_to_notconfirmed" v-model="item.send_to_notconfirmed">Niepotwierdzone adresy e-mail</ui-checkbox>
            <ui-checkbox name="send_to_imported" v-model="item.send_to_imported">Zaimportowani</ui-checkbox>
            <ui-checkbox name="send_to_signout" v-model="item.send_to_signout">Wypisani</ui-checkbox>

          </div>

          <i-select-multiple name="email_groups_ids" label="Grupy" :keys="keysForSelect" v-model="item.email_groups_ids" :options="emailGroups" placeholder="Wybierz grupy" multiple search-placeholder="Szukaj"
              :show-search="true" required></i-select-multiple>
      </fieldset>

      <fieldset>
          <legend>Konto z którego zostanie wysłana wiadomość</legend>
          <i-select name="account" label="Konto do wysłania wiadomości" :keys="keysForSelect" v-model="item.email_account_id" :options="accounts" placeholder="Wybierz konto" required></i-select>

      </fieldset>

      <fieldset>
          <legend>Status</legend>
          <i-select name="status" label="Status" :keys="keysForSelect" v-model="item.status" :options="statuses" placeholder="Wybierz status" required></i-select>

      </fieldset>

      <div class="form-actions">
          <ui-button color="primary">{{ item.id ? 'Aktualizuj' : 'Dodaj' }}</ui-button>
      </div>
  </form>

  <ui-modal ref="modal1" :title="modal.title" :hide-footer="true" size="large">
      <url-preview-form @choose="getUrl"></url-preview-form>
  </ui-modal>
</div>
</template>
<script>
import Loading from '../../mixins/Loading'
import Notify from '../../mixins/Notify'
import FormErrors from '../../mixins/FormErrors'
import Utils from '../../services/Utils'

import Curl from './../../services/Curl'
import Messages from './../../services/Messages'
import Accounts from './../../services/Accounts'
import Templates from './../../services/Templates'
import EmailGroups from './../../services/EmailGroups'

export default {
  mixins: [Loading, Notify, FormErrors],
  props: ['item'],
  data () {
    return {
      errors: [],
      title: 'Dodaj wiadomość',
      action: 'Dodaj wiadomość',
      statuses: Messages.statuses(),
      accounts: [],
      emailGroups: [],
      templates_text: [],
      templates_html: [],
      keysForSelect: Utils.keysForSelect(),
      keysForTemplateSelect: {
        label: 'name',
        value: 'code'
      },
      showHelp: false,
      help:
        '<a href="{{ route(\'email-groups\', {token: token }) }}">Wypisz się z naszego newslettera.</a>.',
      help2:
        '<a href="{{ route(\'email-group-confirm\', {token: confirm_token }) }}">Potwierdź swój email</a>.',
      modal: {
        show: false,
        title: 'Wybierz url'
      },
      errorMessages: Utils.errorMessages([
        'required',
        'min',
        'numeric',
        'email'
      ])
    }
  },
  mounted () {
    if (this.item.id) {
      this.title = 'Aktualizuj wiadomość'
      this.action = 'Aktualizuj wiadomość'
    }
    this.getAccounts()
    this.getGroups()
    this.getTemplates()
  },
  methods: {
    inputC (e) {
      this.item.html_body = e
    },
    resetForm () {
      this.item = Messages.getBaseItem()
    },
    toggleHelp () {
      this.showHelp = !this.showHelp
    },
    importUrl () {
      this.$refs.modal1.open()
    },
    getUrl (url) {
      this.setLoading(true)
      Curl.get(url).then(
        res => {
          this.item.html_body = res.data.html_body
          this.item.text_body = res.data.text_body
          this.setLoading(false)
        },
        () => {
          this.notify(
            'Nie mogłem pobrać zdalnej zawartości z danego adresu url'
          )
          this.setLoading(false)
        }
      )

      this.item.import_html_url = url
      this.$refs.modal1.close()
    },
    getAccounts () {
      this.setLoading(true)
      Accounts.names().then(res => {
        this.accounts = res.data.items
        this.setLoading(false)
      })
    },
    getGroups () {
      this.setLoading(true)
      EmailGroups.names().then(res => {
        this.emailGroups = res.data.items
        this.setLoading(false)
      })
    },
    getTemplates () {
      this.setLoading(true)
      Templates.names().then(res => {
        this.templates_text = res.data.items.filter(
          item => item.template_type === 'text'
        )
        this.templates_html = res.data.items.filter(
          item => item.template_type === 'html'
        )
        this.setLoading(false)
      })
    },
    error (err) {
      this.errors = this.getResponseErrors(err)
      this.notify('Wystąpiły błędy')
    },
    success (res) {
      if (this.item.id) {
        if (res.status === 200) {
          this.notify('Zmieniłeś wiadomość')
          this.$router.push({
            name: 'admin.messages.show',
            params: {
              id: this.item.id
            }
          })
        }
      } else {
        if (res.status === 201) {
          this.notify('Dodałeś wiadomość')
          this.$router.push({
            name: 'admin.messages.show',
            params: {
              id: res.data.item.id
            }
          })
        }
      }
    },
    submit () {
      this.errors = []
      window.scrollTo(0, 0)

      let item = {}
      if (this.item.id) {
        item.id = this.item.id
      }
      item.title = this.item.title
      item.text_body = this.item.text_body
      item.html_body = this.item.html_body
      item.email_account_id = this.item.email_account_id
      item.use_template = this.item.use_template
      item.template_html = this.item.template_html
      item.template_text = this.item.template_text

      item.status = this.item.status
      item.email_groups_ids = this.item.email_groups_ids

      item.send_to_all = this.item.send_to_all
      item.send_to_confirmed = this.item.send_to_confirmed
      item.send_to_notconfirmed = this.item.send_to_notconfirmed
      item.send_to_imported = this.item.send_to_imported
      item.send_to_signout = this.item.send_to_signout

      if (this.item.id) {
        Messages.update(item).then(this.success, this.error)
      } else {
        Messages.create(item).then(this.success, this.error)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// Form.vue?736534ca